import { Store } from "pullstate";

export const NecStore = new Store({
  setting: null,
});

export const jwStore = new Store({
  jw: null,
});
